var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pcm-page",attrs:{"data-theme":_vm.themeAttr}},[_c('PrivateChatModal',{attrs:{"recipient":_vm.recipient},on:{"close":_vm.onClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }